import {AfterViewInit, Component, Directive, Input, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation} from '@angular/core';

import {ToastrService} from 'ngx-toastr';
import {language} from '../../../../language/vn';
import {CommandUtil} from '../../../../global/commandutil';
import {DatePipe} from '@angular/common';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {VanBanDen} from '../../../../models/vanbanden/vanbanden';
import {VanBanDenXL} from '../../../../models/vanbanden/vanbandenxl';
import {VanBanDenService} from '../../../../service/vanbanden/service-vanbanden';
import {VanBanDenFileService} from '../../../../service/vanbanden/service-vanbandenfile';
import {VanBanDenXLService} from '../../../../service/vanbanden/service-vanbandenxl';
import {VanBanDenComment} from '../../../../models/vanbanden/vanbandencomment';
import {NavItemService} from '../../../../service/staff/service-navitem';
import {environment} from '../../../../../environments/environment';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Subject} from 'rxjs';
import {DanhSachTHVanBanDenComponent} from './danhsach.component';
import {VanBanDenCommentService} from '../../../../service/vanbanden/service-vanbandencomment';
import {DomSanitizer} from '@angular/platform-browser';
import {LogView} from '../../../../models/log/logview';
import {LogViewService} from '../../../../service/log/service-logview';
@Component({
  templateUrl: './tonghop.component.html',
  encapsulation: ViewEncapsulation.None

})
export class TongHopYKienVanBanDenComponent implements OnInit, AfterViewInit {
  public id: number = -1;
  public language = language;
  public showAction = true;
  public totalItems: number = 0;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public  onClose: Subject<boolean>;
  public vanBanDenItem: VanBanDen = new VanBanDen();
  public vanBanDenXuLyItem: VanBanDenXL = new VanBanDenXL();
  public vanBanDenCommentList: VanBanDenComment[] = [];
  public permissionGXL: boolean = false;
  public maNguoiXuLy: number = Sessioncommand.staffId;
  public hoanThanhList: VanBanDenXL[] = [];
  public chuaXuLyList: VanBanDenXL[] = [];
  public dangXuLyList: VanBanDenXL[] = [];
  public daXemXuLyList: VanBanDenXL[] = [];
  public vanBanDenXuLyList: VanBanDenXL[] = [];
  public dataComment: Object[] = [];
  public logViewList: LogView[] = [];
    constructor(
    public vanBanDenService: VanBanDenService,
    public toastr: ToastrService,
    public datepipe: DatePipe,
    public commandUtil: CommandUtil,
    public vanBanDenFileService: VanBanDenFileService,
    public vanBanDenXuLyService: VanBanDenXLService,
    public navItemService: NavItemService,
    public bsModalService: BsModalService,
    public _bsModalRef: BsModalRef,
    public vanBanDenCommentService: VanBanDenCommentService,
    public sanitizer: DomSanitizer,
    public logViewService: LogViewService
  ) {
  }
  ngAfterViewInit() {
  }
  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();

  }
  ngOnInit(): void {
    this.onClose = new Subject();
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId, '0032', true).subscribe(
      x => {
        this.permissionGXL = x >0? true: false;
      }
    );
  }
  public getXuLyById(sId: number, s: boolean): string
  {

    let xl: VanBanDenXL = this.vanBanDenXuLyList.find(x => x.maNguoiXuLy === sId);
    return xl == null ? "" : (s === true ?  xl.thoiGianXemLanDau: xl.thoiGianXemLanCuoi);

  }

  public edit(id: number) {
    this.id = id;
    this.vanBanDenService.getById(id).subscribe(data=> this.vanBanDenItem = data);
    this.vanBanDenXuLyService.getAllByMaVB(id).subscribe( data => {this.vanBanDenXuLyList = data;
      this.hoanThanhList = this.vanBanDenXuLyList.filter( x => x.maTrangThaiXL === environment.hoanthanh);
      this.dangXuLyList = this.vanBanDenXuLyList.filter( x => x.maTrangThaiXL === environment.dangxuly);
      this.chuaXuLyList = this.vanBanDenXuLyList.filter( x => x.maTrangThaiXL === environment.chuaxuly && x.xem === 0);
      this.daXemXuLyList = this.vanBanDenXuLyList.filter( x => x.maTrangThaiXL === environment.chuaxuly && x.xem === 1);
    });
    this.loadComment(id);
    this.vanBanDenXuLyService.getByMaVBAndMXL(id, Sessioncommand.staffId).subscribe(
      data => this.vanBanDenXuLyItem = data
    );

  }
  public showXuLy(vanBanList: VanBanDenXL[])
  {
    const modalEdit = this.bsModalService.show(DanhSachTHVanBanDenComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<DanhSachTHVanBanDenComponent>modalEdit.content).edit(
      vanBanList
    );
    (<DanhSachTHVanBanDenComponent>modalEdit.content).onClose.subscribe(result => {
    });
  }
  public onSave(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }
  public loadComment(id: number)
  {
   this.vanBanDenCommentService.getCountByKeyword(id, Sessioncommand.staffId).subscribe( data => this.totalItems = data);
   this.vanBanDenCommentService.findAllByPaging(id, Sessioncommand.staffId, this.currentPage, this.maxSize).subscribe( data => {this.vanBanDenCommentList = data;
         });

  }
  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.loadComment(this.id);
  }

}

